<template>
  <Form></Form>
</template>

<script>
import Form from '../components/Form.vue';

export default {
  name: 'Home',
  components: {
    Form,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>
